import { Message } from '@/components/chat/chatTypes';

const CLOUDFLARE_AI_URL = 'https://gateway.ai.cloudflare.com/v1/7b138c6482866840df4fff59e06428f9/anthropic-sonnet/workers-ai/@cf/meta/llama-3.1-8b-instruct';

interface AIResponse {
  response: string;
  error?: string;
}

export async function generateAIResponse(
  messages: Message[],
  systemPrompt?: string
): Promise<AIResponse> {
  try {
    // Format the conversation history
    const formattedMessages = messages.map(msg => ({
      role: msg.isUser ? 'user' : 'assistant',
      content: msg.content
    }));

    // Prepare the request body
    const requestBody = {
      messages: [
        ...(systemPrompt ? [{ role: 'system', content: systemPrompt }] : []),
        ...formattedMessages
      ],
      stream: false
    };

    // Make the API request
    const response = await fetch(CLOUDFLARE_AI_URL, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${import.meta.env.VITE_CLOUDFLARE_TOKEN}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    });

    if (!response.ok) {
      throw new Error(`AI API error: ${response.statusText}`);
    }

    const data = await response.json();
    return { response: data.response };
  } catch (error) {
    console.error('Error generating AI response:', error);
    return {
      response: 'I apologize, but I encountered an error while processing your request. Please try again.',
      error: error instanceof Error ? error.message : 'Unknown error'
    };
  }
} 